import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M27 30H5l-.176-.008-.19-.026-.123-.027a2 2 0 0 1-1.504-1.776L3 28V15c0-.312.135-.573.339-.75l.106-.082L7 11.797V5l.005-.15.008-.076.02-.142q.024-.126.063-.246l.06-.162.052-.112.083-.152.108-.159.119-.144.136-.136.12-.101.147-.104.142-.083.067-.034.137-.06.203-.068.126-.03.039-.008a2 2 0 0 1 .216-.028L9 3h10a1 1 0 0 1 .608.206l.1.087 5 5a1 1 0 0 1 .283.576L25 9v2.797l3.57 2.382a.98.98 0 0 1 .422.69L29 15v13l-.006.154-.023.186-.032.149a2 2 0 0 1-1.776 1.504zm0-2.001v-11.02l-7.642 5.631a2 2 0 0 1-1.005.382l-.182.008H13.83a2 2 0 0 1-1.035-.289l-.152-.1L5 16.978V28zM9 5h9.585L23 9.415v8.025L18.171 21H13.83L9 17.441zm10 10a1 1 0 0 1 .117 1.993L19 17h-6a1 1 0 0 1-.117-1.993L13 15zm-13.259.04L7 14.201v1.767zM25 14.202v1.765l1.258-.927zM20 12a1 1 0 0 0-1-1h-6l-.117.007A1 1 0 0 0 13 13h6l.117-.007A1 1 0 0 0 20 12"
      clipRule="evenodd"
    />
  </svg>
);
const SvgIconOwnerInvoices = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconOwnerInvoices);
export default Memo;
